import {
  IBlockReason,
  IGetBlockReasonsParams,
} from '@network/models/block-reason.model'
import { IPayload } from '@network/models/global.model'
import { AxiosService } from '@services'
import { Endpoints } from '@network/endpoints'

export class BlockReasonsApi {
  constructor(private axios: AxiosService) {}

  getBlockReasons = async (params?: IGetBlockReasonsParams) => {
    const response = await this.axios.get<IPayload<IBlockReason[]>>(
      Endpoints.getBlockReasons,
      params,
    )
    return response
  }

  getBlockReason = async (id: number, params?: IGetBlockReasonsParams) => {
    const response = await this.axios.get<IPayload<IBlockReason>>(
      Endpoints.getBlockReason(id),
      params,
    )
    return response
  }
}
